export default {"src":"/_next/static/media/folder-simple-user.70a83e02.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};